<template>
  <div :width="300">
    <DxTabPanel id="tabPanel" :defer-rendering="false">
      <DxItem title="Test">
        <template #default>
          <div>hello</div>
        </template>
      </DxItem>
      <DxItem title="Test2">
        <template #default>
          <div>hello2</div>
        </template>
      </DxItem>
    
    </DxTabPanel>
    
  </div>
</template>

<script>
import "devextreme/dist/css/dx.light.css";
import DxTabPanel, { DxItem } from "devextreme-vue/tab-panel";

export default {
  components: {
    DxTabPanel,
    DxItem,
  },
  data() {
    return {};
  },
  methods: {},
};
</script>
